import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { eventsAPI } from '../api';

export default function EventPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    eventsAPI.get(id).then(r => setEvent(r.data)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#9CA3AF' }}>Loading...</div>;
  if (!event) return <div style={{ textAlign: 'center', padding: 60 }}>Event not found</div>;

  const handleProceed = () => {
    if (!selected) return;
    navigate(`/checkout/${id}`, { state: { event, ticketType: selected, quantity } });
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fa' }}>
      {/* Header */}
      <div style={{ background: '#1A2744', padding: '16px 24px', display: 'flex', alignItems: 'center', gap: 16 }}>
        <Link to="/" style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14 }}>← Back</Link>
        <img src="https://omogusiiwarriors.org/icons/logo.png" alt="OWW" style={{ width: 32, height: 32, objectFit: 'contain' }} />
        <span style={{ color: '#fff', fontWeight: 700, fontFamily: "'Playfair Display', serif" }}>Tikoo</span>
      </div>

      {/* Banner */}
      {event.banner_url ? (
        <img src={event.banner_url} alt={event.name} style={{ width: '100%', maxHeight: 350, objectFit: 'cover' }} />
      ) : (
        <div style={{ background: 'linear-gradient(135deg,#1A2744,#E8521A)', height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 64 }}>🎟️</div>
      )}

      <div style={{ maxWidth: 800, margin: '0 auto', padding: '32px 24px' }}>
        <div style={{ fontSize: 13, color: '#E8521A', fontWeight: 700, marginBottom: 8 }}>{event.organizer_name}{event.organization ? ` · ${event.organization}` : ''}</div>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 32, color: '#1A2744', margin: '0 0 16px' }}>{event.name}</h1>

        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 24 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#6B7280', fontSize: 14 }}>
            📅 {new Date(event.date).toLocaleDateString('en-KE', { dateStyle: 'full' })}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#6B7280', fontSize: 14 }}>
            ⏰ {event.time}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#6B7280', fontSize: 14 }}>
            📍 {event.venue}{event.location ? `, ${event.location}` : ''}
          </div>
        </div>

        {event.description && (
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 24, lineHeight: 1.7, color: '#374151' }}>
            {event.description}
          </div>
        )}

        {/* Ticket Types */}
        <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, color: '#1A2744', marginBottom: 16 }}>Select Tickets</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 24 }}>
          {event.ticket_types?.map(tt => {
            const available = tt.quantity - tt.sold;
            const isSelected = selected?.id === tt.id;
            return (
              <div key={tt.id} onClick={() => available > 0 && setSelected(tt)}
                style={{ background: '#fff', border: `2px solid ${isSelected ? '#E8521A' : '#E5E7EB'}`, borderRadius: 12, padding: 20, cursor: available > 0 ? 'pointer' : 'not-allowed', opacity: available === 0 ? 0.5 : 1, transition: 'border-color 0.2s' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 700, color: '#1A2744', fontSize: 16 }}>{tt.name}</div>
                    {tt.description && <div style={{ fontSize: 13, color: '#6B7280', marginTop: 4 }}>{tt.description}</div>}
                    <div style={{ fontSize: 12, color: available < 20 ? '#E8521A' : '#9CA3AF', marginTop: 4 }}>
                      {available === 0 ? 'Sold out' : `${available} available`}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 22, fontWeight: 800, color: tt.price === 0 ? '#2D7D32' : '#1A2744' }}>
                      {tt.price === 0 ? 'Free' : `KSh ${tt.price.toLocaleString()}`}
                    </div>
                    {isSelected && <div style={{ color: '#E8521A', fontSize: 12, fontWeight: 700 }}>✓ Selected</div>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Quantity and Proceed */}
        {selected && (
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, border: '1px solid #E5E7EB' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div>
                <div style={{ fontWeight: 600 }}>{selected.name}</div>
                <div style={{ color: '#6B7280', fontSize: 13 }}>KSh {selected.price.toLocaleString()} each</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <button onClick={() => setQuantity(q => Math.max(1, q - 1))}
                  style={{ width: 32, height: 32, borderRadius: '50%', border: '1px solid #E5E7EB', background: '#f9fafb', cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>−</button>
                <span style={{ fontWeight: 700, fontSize: 18, minWidth: 24, textAlign: 'center' }}>{quantity}</span>
                <button onClick={() => setQuantity(q => Math.min(selected.quantity - selected.sold, q + 1))}
                  style={{ width: 32, height: 32, borderRadius: '50%', border: '1px solid #E5E7EB', background: '#f9fafb', cursor: 'pointer', fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>+</button>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontSize: 18, fontWeight: 800, color: '#1A2744' }}>Total: KSh {(selected.price * quantity).toLocaleString()}</div>
              <button onClick={handleProceed}
                style={{ background: '#E8521A', color: '#fff', padding: '12px 28px', borderRadius: 10, border: 'none', fontWeight: 700, fontSize: 16, cursor: 'pointer' }}>
                Proceed to Payment →
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
